import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import masterDataProto from "src/Library/MasterDataType";
import { useReduxState } from "../../useRedux";
import { useStaticSelect } from '../../form/useSelect';

const useContainerSize = <T>(props: useFieldProps<T>) => {
	const field = useStaticSelect<ReturnType<typeof getOptions>, T>(props);
	const containerSizes: typeof masterDataProto.execution.validContainerSizes = useReduxState(
    ["masterData", "execution", "validContainerSizes"]
  ).value;

  React.useEffect(() => {
    field.setOptionsData(getOptions(), (data) => {
      return data || [];
    });
  }, []);

  const getOptions = () => {
    return containerSizes.map(el => ({ key: el, label: el}));
  };

  return field;
};

export default useContainerSize;
